import { line } from 'd3-shape';
import React from 'react';
import { TagShapeProps } from '../utils/common-graph.utils';
import { GRID_UNIT_SIZE } from '../utils/graph.utils';

export const LaddergramTriangle: React.FC<TagShapeProps> = ({
  color,
  bordered,
  size,
}) => {
  const offset = GRID_UNIT_SIZE;
  const innerSize = size / 2 - offset;

  const points: [number, number][] = [
    [0, innerSize * 2],
    [innerSize, innerSize / 2],
    [innerSize * 2, innerSize * 2],
    [0, innerSize * 2],
  ];

  const pathD = line()(points) || undefined;

  return (
    <>
      {bordered && (
        <g transform={`translate(${size / 2}, ${size / 2})`}>
          <circle r={size / 2} fill='transparent' stroke='black' />
        </g>
      )}

      <g transform={`translate(${offset}, ${offset - innerSize / 3})`}>
        <path fill={color} strokeWidth={GRID_UNIT_SIZE} d={pathD} />
      </g>
    </>
  );
};
